import React from 'react'
import './iconButton.css'; 
const IconButton = function IconButton({onClick,children,style}) {
    return ( 
        <div  onClick={onClick} style={style} className='ui-iconbutton'>{ children}</div> 
    )
}

export { IconButton };
